'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { ReactNode } from 'react';
const EXTERNAL_LINK_PROPS: {
  target: '_blank';
  rel: 'noopener noreferrer';
} = {
  target: '_blank',
  rel: 'noopener noreferrer'
};
export function MoonPayFooterLink(t0) {
  const $ = _c(5);
  const {
    children
  } = t0;
  const t = useTranslations("onramp");
  let t1;
  if ($[0] !== t) {
    t1 = t("provider_name");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <a href="https://www.moonpay.com/" {...EXTERNAL_LINK_PROPS} aria-label={t1} className="inline-flex min-h-11 min-w-11 cursor-pointer items-center justify-center rounded-item focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-foreground-primary">{children}</a>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}